import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Check, AlertTriangle } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import { API } from "../lib/constants";

export default function PaymentSuccess() {
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPayment = async () => {
      const params = new URLSearchParams(window.location.search);
      const sessionId = params.get('session_id') || localStorage.getItem('ris_pending_session');
      if (!sessionId) { setLoading(false); return; }
      try {
        const res = await axios.get(`${API}/store/checkout/status/${sessionId}`);
        setStatus(res.data);
        if (res.data.payment_status === 'paid') {
          localStorage.removeItem('ris_pending_session');
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    checkPayment();
  }, []);

  if (loading) {
    return (<div className="min-h-screen pt-24 flex items-center justify-center"><div className="w-12 h-12 border-2 border-red-600 border-t-transparent rounded-full animate-spin" /></div>);
  }

  const isPaid = status?.payment_status === 'paid';

  return (
    <div className="min-h-screen pt-24 pb-32 px-6 flex items-center justify-center" data-testid="payment-success-page">
      <div className="max-w-md text-center">
        {isPaid ? (
          <>
            <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
              <Check size={40} className="text-green-500" />
            </div>
            <h1 className="font-cinzel text-3xl font-bold mb-4">{status.type === 'donation' ? 'Thank You!' : 'Payment Successful!'}</h1>
            <p className={`mb-2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              {status.type === 'donation'
                ? 'Your donation directly fuels new chapters, characters, and audio production. We are grateful.'
                : (status.credits_total ? `${status.credits_total} credits have been added to your wallet!` : 'Your purchase has been processed.')}
            </p>
            <p className={`text-sm mb-8 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
              Amount: ${(status.amount_total / 100).toFixed(2)} {status.currency?.toUpperCase()}
            </p>
            <div className="flex flex-col gap-3">
              <button onClick={() => navigate('/')} className="btn-primary" data-testid="go-home-btn">Start Reading</button>
              <button onClick={() => navigate('/store')} className="btn-secondary" data-testid="back-to-store-btn">Back to Store</button>
            </div>
          </>
        ) : (
          <>
            <div className="w-20 h-20 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
              <AlertTriangle size={40} className="text-yellow-500" />
            </div>
            <h1 className="font-cinzel text-3xl font-bold mb-4">Payment Pending</h1>
            <p className={`mb-8 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Your payment is being processed. Please check back in a moment.</p>
            <button onClick={() => navigate('/')} className="btn-primary" data-testid="go-home-pending-btn">Go Home</button>
          </>
        )}
      </div>
    </div>
  );
}
